module.exports = __webpack_public_path__ + "static/dcom1-150x150-309bc9cc0330437dd2be0d5d87b8bfd5.png";